import {AfterViewInit, Component, ElementRef, inject, signal, viewChild} from "@angular/core";
import {SimUtilityExtendedService} from "@services";

@Component({
	selector: "sim-audio-element",
	templateUrl: "./audio-element.component.html",
})
export class AudioElementComponent implements AfterViewInit {
	// Properties
	public readonly isPlaying = signal<boolean>(false);
	public readonly audioProgress = signal<number>(0);
	public readonly currentMediaId = signal<string | null>(null);

	// Children
	public readonly element = viewChild.required<ElementRef<HTMLAudioElement>>("audioEl");

	// Injections
	readonly #utilService = inject(SimUtilityExtendedService);

	ngAfterViewInit() {
		this.element().nativeElement.addEventListener("timeupdate", this.updateProgress);
	}

	public async play(mediaId: string) {
		if (!mediaId) {
			return;
		}
		if (this.currentMediaId() !== mediaId) {
			this.stop();
			this.element().nativeElement.src = this.#utilService.getMediaPathById(mediaId);
			this.currentMediaId.set(mediaId);
		}
		this.isPlaying.set(true);
		await this.element().nativeElement.play();
	}

	public pause() {
		this.element().nativeElement.pause();
	}

	public stop() {
		this.element().nativeElement.pause();
		this.audioProgress.set(0);
		this.element().nativeElement.currentTime = 0;
		this.currentMediaId.set(null);
		this.isPlaying.set(false);
	}

	protected updateProgress = () => {
		const audio = this.element().nativeElement;
		const progress = (audio.currentTime / audio.duration) * 100;
		this.audioProgress.set(progress);
		if (progress >= 100) {
			this.stop();
		}
	};
}
